import React, { useState, useEffect, useCallback }  from 'react';
import { MarkerF, GoogleMap, useJsApiLoader } from '@react-google-maps/api';

function LocationMap({loc, user, ...props}) {
  const googleMapsKey = 'AIzaSyCsEuLdHnu5Iyo1xtAe0xg-VGlZ0_xWyhs';
  const [coords, setCoords] = useState(loc ? {lng: loc[0], lat: loc[1]} : {});
  const [map, setMap] = useState();
  const [pin, setPin] = useState();
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleMapsKey
  });
  const baseHeight = '360px';
  const baseWidth = '493px';

  const onLoad = useCallback(function callback(m) {
    m.setZoom(15);
    setMap(m);
  }, []);

  const onUnmount = useCallback(function callback(map) {
    setMap(null);
  }, []);

  useEffect(() => {
    if (!coords || coords === {}) {
      getPosition();
    }
  }, []);

  const savePosition = (newCoords) => {
    if (newCoords.coords) {
      let that = this;
      setCoords({lng: newCoords.coords.longitude, lat: newCoords.coords.latitude});
    } else {
      failPosition();
    }
  }

  const failPosition = (error) => {
    if (user?.location) {
      setCoords({lng: user.location[0], lat: user.location[1]});
    }
  }

  const getPosition = () => {
    // What a crap API navigator.geolocation is... Do not try to try/catch it.
    // Hack to fix geolocation for Safari and Firefox... doesn't work all the time.
    navigator.geolocation.getCurrentPosition(function () {}, function () {}, {});
    navigator.geolocation.getCurrentPosition(savePosition, failPosition);
  }

  const pickLocation = (e) => {
    console.log('[LocationMap]  pickLocation fired!');
    if (props?.postCreator || props?.origin === 'signup') {
      setPin({lat: e.latLng.lat(), lng: e.latLng.lng()});
      if (props.postCreator) {
        props.postCreator.setLocation({loc: [e.latLng.lng(), e.latLng.lat()]});
      }
    }
  }

  return(
    <>
      {
        (coords && isLoaded) ?
          <GoogleMap onClick={(e) => pickLocation(e)} center={coords}
                     onLoad={onLoad} onUnmount={onUnmount} zoom={15}
                     mapContainerStyle={{width: '492px', height: '364px'}}>
            <MarkerF position={pin || coords} />
          </GoogleMap>
        : 'LocationMap: No Coords'
      }
    </>
  );
}

export default LocationMap;
